import { render, staticRenderFns } from "./SMSTemplatesList.vue?vue&type=template&id=4cc1d5f8&scoped=true"
import script from "./SMSTemplatesList.vue?vue&type=script&lang=js"
export * from "./SMSTemplatesList.vue?vue&type=script&lang=js"
import style0 from "./SMSTemplatesList.vue?vue&type=style&index=0&id=4cc1d5f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc1d5f8",
  null
  
)

export default component.exports